import axios from '@/libs/api.request'

export const page = (data) => {
  return axios.request({
    url: '/ad/posGeneral/page',
    method: 'get',
    params: data
  })
}

export const report = (data) => {
  return axios.request({
    url: '/ad/posGeneral/report',
    method: 'get',
    params: data
  })
}

export const getAdPublisherPosTrend = (data) => {
  return axios.request({
    url: '/ad/posGeneral/getAdPublisherPosTrend',
    method: 'get',
    params: data
  })
}

export const getAdSlotStat = (data) => {
  return axios.request({
    url: '/ad/posGeneral/getAdSlotStat',
    method: 'get',
    params: data
  })
}


export const syncData = () => {
  return axios.request({
    url: '/ad/posGeneral/syncData',
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/ad-pos-general.js